import { ReactElement } from 'react';

import Button from '~/ui/components/common/Button';
import ConfirmModal from '~/ui/components/common/ConfirmModal';
import NavigationConfirmModal from '~/ui/components/common/NavigationConfirmModal';

import styles from '../EditAllocationFormLayout/EditAllocationFormLayout.module.scss';

interface IPastDateModalProps {
  description: string;
  onConfirm: () => void;
  onClose: () => void;
}

interface IProps {
  onCancel: () => void;
  isSaveDisabled: boolean;
  leavePageWhen: boolean;
  leavePageDescription: string;
  withClearDraft: boolean;
  onClearDraft?: () => void;
  pastDateModal?: IPastDateModalProps | null;
}

const EditAllocationFormActions = ({
  onCancel,
  isSaveDisabled,
  leavePageWhen,
  leavePageDescription,
  withClearDraft,
  onClearDraft,
  pastDateModal,
}: IProps): ReactElement => (
  <>
    <div className={styles.buttons}>
      <div className={styles.buttonWrapper}>
        <Button color="primary" variant="outlined" onClick={onCancel}>
          Cancel
        </Button>
      </div>
      <Button color="primary" variant="contained" type="submit" disabled={isSaveDisabled}>
        Save Changes
      </Button>
    </div>

    <NavigationConfirmModal
      when={leavePageWhen}
      description={leavePageDescription}
      beforeConfirm={withClearDraft ? onClearDraft : undefined}
    />

    {pastDateModal && (
      <ConfirmModal
        onConfirm={pastDateModal.onConfirm}
        onClose={pastDateModal.onClose}
        description={pastDateModal.description}
        confirmText="Proceed"
      />
    )}
  </>
);

export default EditAllocationFormActions;
